export const PATH_TEMPLATE = ":id";
export const QUERY_PATH_TEMPLATE = `reports/${PATH_TEMPLATE}`;
export const ABSOLUTE_PATH_TEMPLATE = `/admin/${QUERY_PATH_TEMPLATE}`;

export function getPath(id: string, anchor?: string) {
  const path = ABSOLUTE_PATH_TEMPLATE.replace(":id", id);
  if (anchor) {
    return `${path}#${anchor}`;
  }

  return path;
}
